import { AxiosPromise } from 'axios'

import api from '@config/api' // Mantendo o import do seu arquivo de configuração da API

// --- Tipos (Placeholders) ---
// Idealmente, você teria interfaces definidas para estes tipos baseadas nos seus schemas Swagger/OpenAPI
// ex: import { CronogramaComprasDto, AtualizarCronogramaComprasCommand, ... } from './types';
type AtualizarCronogramaComprasCommand = any
type CriarUsuarioComprasCommand = any
type EditarUsuarioComprasCommand = any
type CriarAlcadasComprasCommand = any
type EditarAlcadasComprasCommand = any
type CriarToleranciaCommand = any
type EditarToleranciaCommand = any
type IRequestResult = any // Placeholder para o tipo de resultado padrão

const API_VERSION = 'v1' // Ou qualquer outra versão que você esteja usando como padrão

// --- Serviços para ParametroCompras ---

// Cronograma
export function getCronogramaCompras(
  empresaId: number,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(`/${version}/ParametroCompras/Cronograma/${empresaId}`)
}

export function getCronogramaComprasHistorico(
  empresaId: number,
  usuarioId?: number,
  version: string = API_VERSION
): AxiosPromise<any> {
  const url = usuarioId
    ? `/${version}/ParametroCompras/Cronograma/Historico/${empresaId}/Usuario/${usuarioId}`
    : `/${version}/ParametroCompras/Cronograma/Historico/${empresaId}`
  return api.get(url)
}

export function atualizarCronogramaCompras(
  data: AtualizarCronogramaComprasCommand,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.put(`/${version}/ParametroCompras/Cronograma`, data)
}

export function uploadCronogramaCompras(
  formData: FormData,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.post(`/${version}/ParametroCompras/Cronograma`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// Usuario Compras
export function criarUsuarioCompras(
  data: CriarUsuarioComprasCommand,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.post(`/${version}/ParametroCompras/Usuario`, data)
}

export function editarUsuarioCompras(
  data: EditarUsuarioComprasCommand,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.put(`/${version}/ParametroCompras/Usuario`, data)
}

export function uploadArquivoUsuarioCompras(
  empresaId: number,
  formData: FormData,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  // Assumindo que o upload de arquivo usará FormData
  // Pode ser necessário ajustar os headers para 'multipart/form-data' dependendo da configuração do 'api'
  return api.post(
    `/${version}/ParametroCompras/Usuario/Arquivo/${empresaId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

export function uploadUsuarioArquivo(
  formData: FormData,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.post(`/${version}/ParametroCompras/Usuario/Arquivo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function removerUsuarioCompras(
  idUsuarioCompras: string,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.delete(`/${version}/ParametroCompras/Usuario/${idUsuarioCompras}`)
}

export function getListaUsuarioCompras(
  empresaId: string,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(`/${version}/ParametroCompras/Usuario/${empresaId}`)
}

export function getUsuarioComprasHistorico(
  empresaId: number,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(`/${version}/ParametroCompras/Usuario/Historico/${empresaId}`)
}

// Usuario Mundos
export function getCategoriasFornecedores(
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(
    `/${version}/ParametroCompras/Usuario/Fornecedores/Relacionamentos`
  )
}

export function getFornecedorUsuarioLogado(
  empresaId: number,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(
    `/${version}/ParametroCompras/Usuario/Fornecedores/${empresaId}`
  )
}

// Alcadas Compras
export function criarAlcadasCompras(
  data: CriarAlcadasComprasCommand,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.post(`/${version}/ParametroCompras/Alcadas`, data)
}

export function editarAlcadasCompras(
  data: EditarAlcadasComprasCommand,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.put(`/${version}/ParametroCompras/Alcadas`, data)
}

export function removerAlcadasCompras(
  id: number,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.delete(`/${version}/ParametroCompras/Alcadas/${id}`)
}

export function getListaAlcadasCompras(
  empresaId: number,
  version: string = API_VERSION
): AxiosPromise {
  return api.get(`/${version}/ParametroCompras/Alcadas/${empresaId}`)
}

export function getAlcadasComprasHistorico(
  empresaId: number,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(`/${version}/ParametroCompras/Alcadas/Historico/${empresaId}`)
}
/**
 * @summary Obtém o histórico de alterações das ferias dos compradores
 * @param version A versão da API
 * @returns O histórico de férias dos compradores
 */
export function getFeriasCompradorHistorico(
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(`/${version}/ParametroCompras/Ferias/Historico`)
}
export function getFeriasComprador(
  companieId: string,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(`/${version}/ParametroCompras/Ferias`)
}

/**
 * @summary Criar o parâmetro de ferias do comprador
 * @param data O corpo da requisição para criar as férias do comprador
 * @param version A versão da API
 * @returns O resultado da requisição
 */
export function createFeriasComprador(
  data: any,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.post(`/${version}/ParametroCompras/Ferias`, data)
}

/**
 * @summary Editar o parâmetro de ferias do comprador
 * @param data O corpo da requisição para editar as férias do comprador
 * @param version A versão da API
 * @returns O resultado da requisição
 */
export function updateFeriasComprador(
  data: any,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.put(`/${version}/ParametroCompras/Ferias`, data)
}

export function cargaFerias(
  ferias: Array<{
    CompradorPrincipalEmail: string
    CompradorFeriasEmail: string
    FornecedorId: number
    DataInicio: string
    DataFim: string
  }>,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.post(`/${version}/ParametroCompras/Ferias/Carga`, {
    Ferias: ferias
  })
}

/**
 * @summary Remove os registros das ferias do comprador
 * @param idFeriasComprador O ID do registro de férias a ser removido
 * @param version A versão da API
 * @returns O resultado da requisição
 */
export function deleteFeriasComprador(
  idFeriasComprador: number,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.delete(`/${version}/ParametroCompras/Ferias/${idFeriasComprador}`)
}

// Tolerancia Compras
export function criarTolerancias(
  data: CriarToleranciaCommand,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.post(`/${version}/ParametroCompras/ToleranciaQuantidade`, data)
}

export function editarTolerancias(
  data: EditarToleranciaCommand,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.put(`/${version}/ParametroCompras/ToleranciaQuantidade`, data)
}

export function removerTolerancias(
  id: number,
  version: string = API_VERSION
): AxiosPromise<IRequestResult> {
  return api.delete(`/${version}/ParametroCompras/ToleranciaQuantidade/${id}`)
}

export function getListaTolerancias(
  empresaId: number,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(
    `/${version}/ParametroCompras/ToleranciaQuantidade/${empresaId}`
  )
}

export function getToleranciaQuantidadeUsuario(
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(`/${version}/ParametroCompras/ToleranciaQuantidade/Usuario`)
}

export function getToleranciaQuantidadeHistorico(
  empresaId: number,
  version: string = API_VERSION
): AxiosPromise<any> {
  return api.get(
    `/${version}/ParametroCompras/ToleranciaQuantidade/Historico/${empresaId}`
  )
}

// Exportar Modelo Tabelas
export function exportarModeloTabelas(
  version: string = API_VERSION
): AxiosPromise<Blob> {
  return api.get(
    `/${version}/ParametroCompras/Usuario/Fornecedores/Relacionamentos/Exportar`,
    {
      responseType: 'blob'
    }
  )
}

// --- Exportação Default ---
const ParametroCompraService = {
  // Cronograma
  getCronogramaCompras,
  getCronogramaComprasHistorico,
  atualizarCronogramaCompras,
  uploadCronogramaCompras,
  // Usuario Compras
  criarUsuarioCompras,
  editarUsuarioCompras,
  uploadArquivoUsuarioCompras,
  uploadUsuarioArquivo,
  removerUsuarioCompras,
  getListaUsuarioCompras,
  getUsuarioComprasHistorico,
  // Usuario Mundos
  getCategoriasFornecedores,
  getFornecedorUsuarioLogado,
  // Alcadas Compras
  criarAlcadasCompras,
  editarAlcadasCompras,
  removerAlcadasCompras,
  getListaAlcadasCompras,
  getAlcadasComprasHistorico,
  getFeriasComprador,
  getFeriasCompradorHistorico,
  createFeriasComprador,
  updateFeriasComprador,
  deleteFeriasComprador,
  cargaFerias,
  // Tolerancia Compras
  criarTolerancias,
  editarTolerancias,
  removerTolerancias,
  getListaTolerancias,
  getToleranciaQuantidadeUsuario,
  getToleranciaQuantidadeHistorico,
  // Exportação
  exportarModeloTabelas
}

export default ParametroCompraService
